import * as React from "react";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useParams } from "react-router-dom";
import { Grid } from "@mui/material";
import theme from "../../../Global/theme";
import { setCurrentStep, setsteps } from "../Stepper/stepperSlice";
import { useDispatch } from "react-redux";
import NavbarStepper from "../Stepper/NavBarStepper";
import { TextField, InputAdornment } from "@mui/material";
import Alert from "@mui/material/Alert";
import { useEditJobCardMutation } from "../../api/apiSlice";
import { showError } from "../../../Global/notifications/notificationsSlice";
import { useConnectionMonitor } from "../connectionsTest";
import ConnectionAlert from "../ConnectionAlert";
import { useStepperStateRestoration } from "../useStepperStateRestoration";

export default function Uninstall() {
  // Stepper state restoration
  useStepperStateRestoration();

  // Connection monitoring
  const {
    showAlert,
    showWeakWarning,
    handleRetry,
    handleDismiss,
    handleWeakWarningDismiss,
    responseTime,
    avgResponseTime,
    connectionDetails
  } = useConnectionMonitor();

  let { serial_number } = useParams();
  let { imsi_number } = useParams();
  let { job_card_reference_id } = useParams();
  let { uninstall } = useParams();
  let navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setsteps(uninstall === "UN" ? [0, 1, 2, 3] : [0, 1, 2, 3, 4, 5, 6, 7]));
    dispatch(setCurrentStep(2));
  }, []);

  const [notes, setNotes] = React.useState("");
  const [
    editJobCard,
    { data: job_card, isSuccess: isEditJobCardSuccess, isError: isEditJobCardError },
  ] = useEditJobCardMutation();


  
  const handleChangeNotes = (event) => {
    setNotes(event.target.value);
  };

  const handlNext = () => {
    const body = {
      state: uninstall=="UN"? "AFT" : "QRCRE" ,
      serial_number: serial_number,
      imsi_number: imsi_number,
      reference_id: job_card_reference_id,
      installer_notes: notes,
    };
    editJobCard({ body: body });
  };



  React.useEffect(() => {
    if (isEditJobCardSuccess) {
      if (uninstall === "UN") {
        navigate(`/installer/${job_card_reference_id}/${serial_number}/${imsi_number}/after_install/`);
      } else {
        navigate(`/installer/${job_card_reference_id}/qrcode/replacement/`);
      }
    }
  }, [isEditJobCardSuccess]);

  React.useEffect(() => {
    if (isEditJobCardError) {
       dispatch(showError("Error"));
    }
  }, [isEditJobCardError]);


  return (
    <>
      {/* Connection Alert */}
      {showAlert && (
        <ConnectionAlert
          onRetry={handleRetry}
          onClose={handleDismiss}
          connectionDetails={connectionDetails}
          position="top"
          alertType="error"
        />
      )}
      
      {/* Weak Connection Warning */}
      {showWeakWarning && (
        <ConnectionAlert
          onRetry={handleRetry}
          onClose={handleWeakWarningDismiss}
          connectionDetails={connectionDetails}
          position="top"
          alertType="warning"
          responseTime={responseTime || avgResponseTime}
        />
      )}
      
      <NavbarStepper />
      <Grid container alignItems="center" justifyContent="center">

        <Grid item xs={12} align="center">
          <Typography variant="h5" color="grey" sx={{ mb: 2 }}>
           Uninstall
          </Typography>
        </Grid>

  
        <Grid item xs={10} align="center" sx={{ mt: 2, mb: 2 }}>
          <TextField
            label="Installer Notes"
            value={notes}
            onChange={handleChangeNotes}
            multiline
            rows={6}
            variant="outlined"
            fullWidth
            placeholder="Capture additional installation notes here..."
          />
        </Grid>
        <Grid item xs={4} />
        <Grid item xs={4} align="center">
          <Button
            style={theme.yellowButtonStyle.root}
            onClick={() => handlNext()}
          >
            Next
          </Button>
        </Grid>
        <Grid item xs={4} />
      </Grid>
    </>
  );
}
